import React from "react";
import HeroSection from "../../BlogPostHero";
import PostContent from "../../BlosPostContent";
import PostRightSide from "../../BlogPostRightContent";
import Layout from "../../Layout"
import Head from "../../Head"
const BlogPageComponent = ({ pageContext: { post, rightContent } }) => {
  return (
    <Layout gradient="container">
      <Head graphTags={post?.graphTags} post={post}/>
      <HeroSection blogPost={post} />
      <div className="bg-blog-area">
        <div className="container mx-auto lg:flex py-40 lg:px-12 xl:px-2">
          <div className="lg:w-9/12 w-11/12 mx-auto lg:pr-20">
            {
              post?.content &&
              <PostContent blogPost={post} />
            }
          </div>
          <div className="lg:w-3/12 w-11/12 mx-auto">
            <PostRightSide rightContent={rightContent && rightContent} />
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default BlogPageComponent;